namespace Gamification.Gamification {
    export interface TipologieEsperienzeForm {
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.StringEditor;
    }

    export class TipologieEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.TipologieEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TipologieEsperienzeForm.init)  {
                TipologieEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(TipologieEsperienzeForm, [
                    'Nome', w0,
                    'Descrizione', w0
                ]);
            }
        }
    }
}
